import { useEffect, useReducer } from "react";

import {
  createContext,
  useContextSelector as useContextSelectorBase,
} from "common/context";

import reducer from "./reducer";
import { INITIAL_STATE } from "./initialState";

export const UiContext = createContext();

const initializer = (path) => (initialValue = INITIAL_STATE) => {
  if (!path) return initialValue;
  const json = JSON.parse(localStorage.getItem(path));
  return json || initialValue;
};

export default function RestaurantProvider({
  children,
  onChange,
  storagePath,
}) {
  const [data, dispatch] = useReducer(
    reducer,
    INITIAL_STATE,
    initializer(storagePath)
  );

  useEffect(() => {
    if (data && storagePath) {
      const dataStr = JSON.stringify(data);
      localStorage.setItem(storagePath, dataStr);
    }
    if (onChange) onChange(data);
  }, [data]);

  return (
    <UiContext.Provider value={[data, dispatch]}>{children}</UiContext.Provider>
  );
}

export const useLocalSelector = (selector, comparator) =>
  useContextSelectorBase(UiContext, (v) => selector(v[0]), comparator);
export const useLocalDispatch = () =>
  useContextSelectorBase(UiContext, (v) => v[1]);
